import { destroy as destroyRF } from 'redux-form'
import { destroy as destroySFM, prevFetch } from 'loankeeper-common/helpers/SimpleFetchManager'
import { destroy as destroyLKG } from '../shared/LKGrid'
import { RF_NAME, LK_GRID_NAME, COLLATERALS_FETCHER_NAME } from './constants'
import { collateralSearchAgain, destroyCollateralsSearch } from 'src/store/collateral'

export const closeCollGrid = () => destroyLKG(LK_GRID_NAME)

export const closeSearchBar = () => destroyRF(RF_NAME)

// export const deleteCollaterals = () => destroySFM(COLLATERALS_FETCHER_NAME)
export const deleteCollaterals = () => destroyCollateralsSearch()

export const destroy = () => [closeCollGrid(), closeSearchBar(), deleteCollaterals()]

// export const searchAgainCollaterals = () => prevFetch({ instanceName: COLLATERALS_FETCHER_NAME })
export const searchAgainCollaterals = () => collateralSearchAgain(COLLATERALS_FETCHER_NAME)
